
<template>
    <div v-if="loaded">
        <div id="maschinevue">
            <div id="maschineContainer">
                <!-- <div id="bonbons"></div> -->
                <clouds></clouds>
                <div id="maschineSVG" v-html="maschineSVG">
                </div>
                <div id="wheel">
                    <div class="innerWheel" v-html="wheel"></div>
                </div>
                <div id="wheelSmall">
                    <div class="innerWheel" v-html="wheelSmall"></div>
                </div>
                <div id="maschineSVGOverlay" v-html="maschineSVGOverlay"></div>
                <div id="speedometer">
                    <div class="speedometerInner">
                        <div class="inner"></div>
                    </div>
                </div>
                <div id="speedometer2">
                    <div class="speedometerInner">
                        <div class="inner"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import eventBus from "../eventBus";

import Clouds from './Clouds';

export default {
    name: "maschine",
    props: ['active', 'combination'],
    data() {
        return {
            loaded: false,
            currentSpeed: 0.0,
            destinationSpeed: 0.0,
            maxSpeed: 2.5,
            minSpeed: 0.1,
            maschineSVG: '',
            maschineSVGOverlay: '',
            wheel: '',
            wheelSmall: '',
            colors: []
        }
    },
    components: {
        clouds: Clouds,
    },
    created() {
        this.fetchData(() => {
            this.colors = window.colors;
            this.loaded = true;
            setTimeout(() => {
                Velocity(document.getElementById('maschineContainer'), 'stop');
                Velocity(document.getElementById('maschineContainer'), {
                    tween: [0, 1000]
                }, {
                    duration: 2000,
                    easing: 'linear',
                    loop: true,
                    progress: this.animateFrame
                });
                this.animateDrop();
            }, 500);   
        });
        document.addEventListener("keyup", this.keyUp);
        eventBus.$on("highlight", this.highlight);
        eventBus.$on("successStep", this.successStep);
        eventBus.$on("cleanColors", this.cleanColors);
        eventBus.$on("showResult", this.showResult);
        eventBus.$on("hideResult", this.hideResult);
        eventBus.$on("reset", this.reset);
        eventBus.$on("hide", this.hide);
    },
    beforeDestroy() {
        this.loaded = false;
        document.removeEventListener("keyup", this.keyUp);
        eventBus.$off("highlight", this.highlight);
        eventBus.$off("successStep", this.successStep);
        eventBus.$off("cleanColors", this.cleanColors);
        eventBus.$off("showResult", this.showResult);
        eventBus.$off("hideResult", this.hideResult);
        eventBus.$off("reset", this.reset);
        eventBus.$off("hide", this.hide);
    },
    methods: {
        fetchData(callback) {
            var requests = [];
            requests.push(axios.get(window.dataPath + "image/maschine.svg"));
            requests.push(axios.get(window.dataPath + "image/maschineOverlay.svg"));
            requests.push(axios.get(window.dataPath + "image/wheel.svg"));
            requests.push(axios.get(window.dataPath + "image/wheel_small.svg"));
            
            axios.all(requests).then(axios.spread((maschine, overlay, wheel, wheelSmall) => {
                this.maschineSVG = maschine.data;
                this.maschineSVGOverlay = overlay.data;
                this.wheel = wheel.data;
                this.wheelSmall = wheelSmall.data;           

                if (callback) callback();
            }));
        },
        animateFrame() {
            this.factor = this.currentSpeed > 0 ? this.currentSpeed / this.maxSpeed : 0;
            this.factor += this.minSpeed;

            this.updateSpeedometer();
            this.updateWheels();

            if (this.destinationSpeed > 0) {
                this.destinationSpeed -= 0.01 + (this.destinationSpeed * 0.01);
                if (this.destinationSpeed < 0) {
                    this.destinationSpeed = 0;
                }
            }

            let lerp = (v0, v1, t) => { return v0 * (1 - t) + v1 * t; };
            this.currentSpeed = this.destinationSpeed < 0.001 ? 0 : lerp(this.currentSpeed, this.destinationSpeed, 0.25);
        },
        /**
         * Animieren der Tachos.
         */
        updateSpeedometer() {
            let factor = this.factor;
            let scale = (factor, min, max) => { return (factor * (max + Math.abs(min))) - Math.abs(min); };
            var svg = document.getElementById('maschineContainer');
            if (svg) { 
                var speedometer = svg.getElementsByClassName('speedometerInner');
                if (speedometer.length > 1) {
                    Velocity(speedometer[0], { rotateZ: scale(factor, -85, 60) + 'deg' }, { duration: 0, queue: false });
                    Velocity(speedometer[1], { rotateZ: scale(factor, 0, 315) + 'deg' }, { duration: 0, queue: false });
                }
            }
        },     
        /**
         * Animieren des Randantriebes.
         */
        updateWheels() {
            var value = this.currentSpeed + this.minSpeed;
            var svg = document.getElementById('maschineContainer');
            if (svg) { 
                var wheel = svg.getElementsByClassName('innerWheel');
                if (wheel) {
                    Velocity(wheel, {
                        rotateZ: '+=' + value + 'deg'
                    }, { duration: 0 });
                }
            }
        },
        /**
         * Fürs bearbeiten/animation der Tasteneingaben.
         * 
         * @param {*} currentKey Der Key-Code der Taste die gedrück wurde. 
         */
        keyUp(e) {
            e.preventDefault();
            if (!this.active) return;
            eventBus.$emit('createCloud');
            var currentKey = e.key;
            this.destinationSpeed = Math.min(this.destinationSpeed + 0.5 + (this.destinationSpeed * 0.01), this.maxSpeed);
        },
        /**
         * Highlighte eine Farbe in der Maschine.
         * 
         * @param {*} index Zur erkenndung der Farbelement (1 - 4). 
         * @param {*} color Die Farbe in der eingefärbt werden soll.
         */
        successStep(index, color, duration, delay) {
            if (!this.active) return;
            let svg = document.getElementById('maschineSVG');

            duration = duration ? duration : 0;
            delay = delay ? delay : 0;

            Velocity(svg.getElementsByClassName('color' + (index + 1)), 'stop');
            Velocity(svg.getElementsByClassName('color' + (index + 1)), {
                fill: color
            }, {
                duration: duration,
                queue: false,
                delay: delay
            });
        },
        /**
         * Slide die Maschine nach links um platz für die Resultate der Spielrunde zu machen.
         */
        showResult(offset) {
            document.getElementById('bonbons').innerHTML = '';
            let element = document.getElementById('maschineContainer');
            Velocity(element, {
                left: -offset + 'px',
                //opacity: 0
            }, {
                duration: 750,
                loop: false,
                queue: false
            });
        },

        /**
         * Versteckt die Resultate der letzten Spielrunde.
         */
        hideResult() {
            let element = document.getElementById('maschineContainer');
            Velocity(element, {
                left: 0 + 'px',
                opacity: 1
            }, {
                duration: 750,
                easing: 'easeOutQuad',
                loop: false,
                queue: false
            });
        },
        /**
         * Stellt die Ausgangsfarben der Maschine her.
         * 
         * @param {*} duration Die Zeit der Animation.
         */
        cleanColors(duration) {
            duration = duration ? duration : 250;

            var svg = document.getElementById('maschineSVG');
            
            if (svg) {
                let maschine = svg.querySelector('#maschine');   
                for (var i = 0; i < 8; i++) {     
                    if (maschine) {
                        let elements = maschine.getElementsByClassName('color' + (i + 1));
                        Velocity(elements, {
                            fill: '#FFFFFF'
                        }, {
                            duration: duration,
                            queue: false,
                            easing: 'linear',
                            delay: 100 + (duration * i)
                        });
                    }
                }
            }
        },
        unhighlight() {
            let svg = document.getElementById('maschineSVG');
            for (var i = 0; i < this.combination.length; i++) {
                Velocity(svg.getElementsByClassName('color' + (i + 1)), {
                    fill: '#FFFFFF'
                }, {
                    duration: 250,
                    easing: "easeOutQuad"
                });
            }
        },
        highlight(duration) {
            duration = duration ? duration : 1500;
            this.unhighlight();
            let svg = document.getElementById('maschineSVG');
            for (var i = 0; i < this.combination.length; i++) {
                let index = parseInt(this.combination[i]);
                let color = this.colors[index - 1];
                let className = 'color' + (i + 1);
                Velocity(svg.getElementsByClassName(className), {
                    fill: color
                }, {
                    duration: 750,
                    delay: (duration * i) + 1000,
                    easing: "easeInQuad"
                });
            }

            setTimeout(() => {
                this.unhighlight();
            }, this.combination.length * duration + 2500);
        },
        hide() {
            let element = document.getElementById('maschineContainer');
            Velocity(element, {
                opacity: 0
            }, {
                duration: 500,
                loop: false,
                queue: false
            });
        },
        /**
         * Der Tropfen wird animiert.
         */
        animateDrop() {
            var drop = document.getElementById('kasten4Tropfen');
            function anim() {
                Velocity(drop, {
                    translateY: "-30px"
                }, 0);
                Velocity(drop, {
                    translateY: "34px"
                }, {
                        duration: 1000,
                        complete: anim,
                        easing: "easeInQuad"
                    });
            };
            anim();
        },
        /**
         * Reset der Maschine - Keine Wolken, keine Farben, nicht aktiv.
         */
        reset() {
            this.active = false;
            if (!this.loaded) return;

            this.$nextTick(() => {
                this.cleanColors();
                var clouds = document.getElementById('clouds');
                if (clouds) clouds.innerHTML = '';
            });
        }
    }
}
</script>

<style lang="scss">
@import "../style/animate.css";
@import "../style/transitions.scss";
@import "../style/basic.scss";

#maschinevue {
    position: absolute;
    top: 150px;
    left: 0; 
    height: calc(100% - 150px);
    min-height: 873px;
    max-height: 873px;
    width: 100%;
    overflow: hidden;

    #maschineContainer {
        position: absolute;
        height: 100%;
        left: 0;

        #maschineSVG, #maschineSVGOverlay {
            position: absolute;
            width: 100%;
            height: 100%;
            left: 50%;
            transform: translateX(-50%);

            svg {
                height: calc(100% - 150px);
                overflow: visible;
            }
        }

        #wheel {
            position: absolute;
            left: 407px;
            top: 142px;
            height: 22.5%;

            .innerWheel {
                height: 100%;
                svg {
                    height: 100%;
                }
            }
        }

        #wheelSmall {
            position: absolute;
            height: 22.5%;
            left: 651.3px;
            top: 234px;

            .innerWheel {
                height: 100%;
                svg {
                    height: 100%;
                }
            }
        }

        #speedometer, #speedometer2 {
            position: absolute;
            left: calc(459.452px);
            top: calc(344.525px - 6px);

            .speedometerInner {
                
                width: 3px;
                height: 15px;
                
                .inner {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: -5.5px;
                    background: black;
                }
            }
        }

        #speedometer2 {
            left: calc(896.871px - 1.5px);
            top: calc(361px - 3.5px);

            .speedometerInner {
                
                width: 3px;
                height: 11px;
                
                .inner {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: -4px;
                    background: black;
                }
            }
        }
    }
}
</style>






// WEBPACK FOOTER //
// src/components/Maschine.vue